import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    position: 'relative',
    height: 'var(--app-height)',
    minHeight: '550px',
  },
  navPanel: {
    position: 'absolute',
    width: '100%',
    bottom: '0',
    transform: 'translateX(-50%)',
    left: '50%',
    zIndex: 2,
  },
  screenWrapper: (props: { background: string }) => ({
    width: '100%',
    height: '100%',
    background: props.background || 'white',
    // backgroundPositionX: '10%',
    backgroundSize: '100% 100%',
  }),
  launchScreenWrapper: {
    width: '100%',
    height: 'var(--app-height)',
    overflow: 'hidden',
    position: 'relative',
  },

  fadeout: {
    animation: '$cloudyFadeOutLeft 1s ease-out forwards',
    opacity: 1,
    eventPointer: 'none',
  },
  fadein: {
    // animation: '$fadeIn 1s ease-out forwards',
    opacity: 1,
    eventPointer: 'none',
  },

  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      filter: 'blur(10px)',
      // transform: 'translateX(-40px)',
    },
    '100%': {
      opacity: 1,
      filter: 'blur(0)',
      transform: 'translateX(0)',
    },
  },

  '@keyframes cloudyFadeOutLeft': {
    '0%': {
      opacity: 1,
      filter: 'blur(0)',
      transform: 'translateX(0)',
    },
    '100%': {
      opacity: 0,
      filter: 'blur(10px)',
      // transform: 'translateX(-40px)',
    },
  },
}));
